<template>
  <div>
    <popup
      :opened="dataToShowSubscription"
      @close="changeToShowSubscription(false)"
    >
      <div class="sticky top-0 z-10">
        <!-- Save button -->
        <div
          class="absolute w-14 h-14 right-1 mt-13 mr-13 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white"
        >
          <icon name="save" class="h-6 w-6 ml-4 mt-1/4" />
        </div>
      </div>

      <div class="m-5 lg:m-15 2xl:m-20 flex flex-col items-center">
        <h3>{{ structureToEdit.name }}</h3>
        <div class="grid grid-cols-3 items-center gap-5 mt-15">
          <p class="col-span-2">Début de l'abonnement :</p>
          <p class="col-span-1">
            {{ structureToEdit.dateDeb }}
          </p>
          <p class="col-span-2">Fin de l'abonnement :</p>
          <p class="col-span-1">
            {{ structureToEdit.dateExp }}
          </p>
          <p class="col-span-2">Type d'abonnement :</p>
          <p class="col-span-1">
            {{ structureToEdit.typeAbo }}
          </p>
          <p class="col-span-2">Renouvelement automatique :</p>
          <p class="col-span-1">Non</p>
          <p class="col-span-2">Nombre de Neopass total :</p>
          <p class="col-span-1">
            {{ structureToEdit.nbNeopass }}
          </p>
          <p class="col-span-2">Nombre de Neopass utilisés :</p>
          <p class="col-span-1">
            {{ structureToEdit.nbUsed }}
          </p>
          <p class="col-span-2">Nombre de Neopass restants :</p>
          <p class="col-span-1">
            {{
              parseInt(structureToEdit.nbNeopass) -
              parseInt(structureToEdit.nbUsed)
            }}
          </p>
          <div class="col-start-1 col-span-full flex justify-center">
            <action-button
              class="mt-10"
              border-color="border-transparent"
              text-color="text-gray-900"
              bg-color="bg-indigo-300"
              bg-color-square="bg-indigo-100"
              icon-color="text-indigo-600"
              libelle="Ajouter Neopass"
              :right="true"
              :responsive="true"
              icon="plus"
            />
          </div>
        </div>
      </div>
    </popup>

    <div
      class="hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
    >
      <div class="px-12">
        <p class="text-4xl text-gray-900">Historique des mouvements</p>
        <p
          class="mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 xl:pr-72"
        >
          Ici sont listés tous les mouvements liés aux utilisateurs du Neopass :
          Création de compte, Rattachement, Détachement et Souscription à un
          abonnement.
        </p>
      </div>
      <illustration
        name="Group189"
        class="hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72"
      />
    </div>
    <div>
      <!-- Contenu -->
      <div class="flex flex-col mt-16 mb-16">
        <div class="-my-2 py-2">
          <div
            class="relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
          >
            <h3 class="mt-10 mb-10 lg:mb-15 w-full">
              Historique des mouvements
            </h3>

            <div class="text-center text-gray-600 cursor-pointer">
              <div
                @click="tabDisplay = 'structures'"
                class="text-2xl inline-block hover:text-pink-600 font-light"
                :class="{
                  'text-indigo-600 font-normal': tabDisplay == 'structures',
                }"
              >
                Structures
              </div>

              <div
                @click="tabDisplay = 'particuliers'"
                class="text-2xl inline-block sm:ml-5 xl:ml-10 hover:text-pink-600 font-light"
                :class="{
                  'text-indigo-600 font-normal': tabDisplay == 'particuliers',
                }"
              >
                Particuliers
              </div>
            </div>

            <!-- Search menu dropdown -->
            <div
              class="flex content-center items-center justify-between align-baseline mt-16 mb-10 mx-15"
            >
              <div class="flex justify-start">
                <div class="flex justify-start items-center cursor-pointer">
                  <div
                    class="flex justify-start items-center cursor-pointer tour_fiches_postes_filtrer"
                    @click="displayFilter"
                    @click.stop
                  >
                    <div
                      class="bg-teal-300 text-teal-600 max-h-8 rounded-full inline-flex items-center p-2"
                    >
                      <icon class="h-4 w-4" name="height" />
                    </div>
                    <div class="hidden lg:flex items-center mx-2">
                      <p class="text-lg text-gray-900 text-center select-none">
                        Filtrer l'historique
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  class="filterbox z-10 absolute mt-9 rounded-md bg-white w-128 shadow-md shadow-gray-600 text-base ml-auto"
                  v-if="showFilter"
                  v-click-outside="displayFilter"
                >
                  <div class="mx-5 my-3">
                    <div class="text-base text-indigo-600 text-left">
                      <input-select
                        name="type"
                        libelle="Filtrer par mouvement"
                        :datas="[{ value: 'Tout' }, ...filters]"
                        :inherits="true"
                        :left="true"
                        @input="
                          (newValue) => {
                            typeFilter = newValue;
                          }
                        "
                        class="lg:w-full my-8"
                        :value="typeFilter"
                      />
                    </div>
                    <div class="grid grid-cols-12 gap-x-4" v-if="false">
                      <div class="col-span-6">Type</div>
                      <div class="col-span-6">Mouvement</div>
                      <div class="col-span-6">
                        <checkbox-indigo
                          v-for="(type, index) in uniqueTypes"
                          :key="index + 'T' + uniqueTypes.get(type[0])"
                          :name="type[0]"
                          :libelle="type[0]"
                          :value="uniqueTypes.get(type[0])"
                          @input="
                            (newValue) => {
                              updateFilter(uniqueTypes, type[0], newValue);
                            }
                          "
                        />
                      </div>
                      <div class="col-span-6">
                        <checkbox-indigo
                          v-for="(move, index) in uniqueMovements"
                          :key="index + 'M'"
                          :name="move[0]"
                          :libelle="move[0]"
                          :value="uniqueMovements.get(move[0])"
                          @input="
                            (newValue) => {
                              updateFilter(uniqueMovements, move[0], newValue);
                            }
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex justify-end flex-grow">
                <sort-button
                  :sort="sort"
                  @sorted="
                    (sortType) => {
                      sort = sortType;
                    }
                  "
                />
              </div>
            </div>

            <div class="flex content-end items-end justify-end align-baseline">
              <div class="flex mr-15 h-12 w-28">
                <action-button
                  libelle="Rafraîchir"
                  text-color="text-white"
                  bg-color="bg-indigo-600"
                  @clickAction="refreshHistory"
                />
              </div>
            </div>

            <div
              class="h-16 lg:h-24 2xl:h-32 text-lg text-gray-600 grid grid-cols-12 gap-x-4 place-content-center mt-10"
            >
              <div class="col-span-2 ml-15">Date</div>
              <div class="col-span-3">Client</div>
              <div class="col-span-2">Type</div>
              <div class="col-span-5">Mouvement</div>
            </div>

            <div
              v-if="isLoading"
              class="flex items-center justify-center w-full"
            >
              <span
                class="w-5 h-5 rounded-full border-t-2 border-r animate-spin border-gray-600"
              />
            </div>

            <div
              v-if="!isLoading && sortedHistory.length === 0"
              class="flex justify-center w-full"
            >
              Aucun résultat
            </div>

            <div
              v-for="(history, idhisto) in sortedHistory"
              :key="idhisto"
              :class="'h-16 lg:h-24 2xl:h-32 text-base bg-white even:bg-gray-200 even:bg-opacity-50 grid grid-cols-12 gap-x-4 place-content-center items-center'"
            >
              <div class="col-span-2 ml-15">
                {{ new Date(history.date).toLocaleDateString('fr') }}
              </div>
              <div class="col-span-3">
                {{ history.client }}
              </div>
              <div class="col-span-2">
                {{ history.type }}
              </div>
              <div class="col-span-5">
                {{ history.movement }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from './../../components/Icon';
import ActionButton from './../../components/ActionButton';
import axios from '../../api';
import Popup from './../../components/Popup';
import Illustration from './../../components/Illustration';
import CheckboxIndigo from './../../components/Inputs/CheckboxIndigo';
import SortButton from './../../components/SortButton';
import InputSelect from '../../components/Inputs/InputSelect';

import ClickOutside from 'vue-click-outside';

export default {
  components: {
    Icon,
    ActionButton,
    Popup,
    Illustration,
    CheckboxIndigo,
    SortButton,
    InputSelect,
  },

  name: 'HistoryMove',

  data() {
    return {
      histories: [],
      dataToShowSubscription: false,
      structureToEdit: {},
      showInactive: false,
      sort: 'DEC',
      showFilter: false,
      typeFilter: 'Tout',
      tabDisplay: 'structures',
      userTypes: ['Professionnel', 'Particulier'],
      listFiltersStructures: [
        'Création compte',
        'Souscription',
        'Attachement bénéficiaire',
        'Détachement bénéficiaire',
      ],
      listFiltersParticuliers: [
        'Création compte',
        'Attachement structure',
        'Détachement structure',
      ],
      isLoading: false,
    };
  },

  uniqueTypes() {
    let allTypes = this.histories.map((history) => [history.type, true]);
    allTypes.splice(0, 0, ['Tout', true]);
    return new Map(allTypes);
  },

  mounted() {
    this.refreshHistory();
  },

  computed: {
    listHistories() {
      return this.histories.filter(
        (history) =>
          (this.tabDisplay === 'particuliers' &&
            history.type === 'Particulier') ||
          (this.tabDisplay === 'structures' && history.type != 'Particulier')
      );
    },

    filteredHistory() {
      if (this.typeFilter === 'Tout' || this.typeFilter === '') {
        return this.listHistories;
      }

      switch (this.typeFilter) {
        case 'Création compte':
          return [...this.listHistories].filter((history) => {
            return (
              history.movement.startsWith('Nouveau compte') ||
              history.movement.startsWith('Nouvelle structure')
            );
          });

        case 'Souscription':
          return [...this.listHistories].filter((history) => {
            return history.movement.startsWith('Nouvel abonnement');
          });

        case 'Attachement bénéficiaire':
          return [...this.listHistories].filter((history) => {
            return history.movement.startsWith('Bénéficiaire rattaché');
          });

        case 'Détachement bénéficiaire':
          return [...this.listHistories].filter((history) => {
            return history.movement.startsWith('Bénéficiaire détaché');
          });

        default:
          return this.listHistories;
      }
    },

    sortedHistory() {
      let sortedHistory = [];

      if (['ABC', 'ZYX'].includes(this.sort)) {
        sortedHistory = [...this.filteredHistory].sort(function (a, b) {
          let nameA = a.client.toUpperCase();
          let nameB = b.client.toUpperCase();
          return nameA.localeCompare(nameB);
        });
      }

      if (['JAN', 'DEC'].includes(this.sort)) {
        sortedHistory = [...this.filteredHistory].sort(function (a, b) {
          let dateA = a.date;
          let dateB = b.date;
          return dateA.localeCompare(dateB);
        });
      }

      if (['ABC', 'JAN'].includes(this.sort)) {
        return sortedHistory;
      }
      if (['ZYX', 'DEC'].includes(this.sort)) {
        return sortedHistory.reverse();
      }

      return sortedHistory;
    },

    uniqueTypes() {
      let allTypes = this.listHistories.map((history) => [history.type, true]);
      allTypes.splice(0, 0, ['Tout', true]);
      return new Map(allTypes);
    },

    uniqueMovements() {
      let allMoves = this.listHistories.map((history) => history.movement);
      let uniqueMoves = new Map();
      uniqueMoves.set('Tout', true);
      allMoves.forEach((move) => {
        if (move.includes('Nouvel abonnement avec')) {
          uniqueMoves.set('Nouveaux abonnements', true);
        } else {
          uniqueMoves.set(move, true);
        }
      });

      return uniqueMoves;
    },

    filters() {
      return this.tabDisplay === 'particuliers'
        ? this.listFiltersParticuliers.map((f) => ({ value: f }))
        : this.listFiltersStructures.map((f) => ({ value: f }));
    },
  },

  methods: {
    updateFilter(filter, item, newValue) {
      if (item === 'Tout') {
        filter.forEach((value, key) => {
          console.log(value, key, newValue);
          filter.set(key, newValue);
        });
      }

      filter.set(item, newValue);
    },

    displayFilter() {
      this.showFilter = !this.showFilter;
    },

    changeToShowSubscription(state) {
      if (!state) {
        this.structureToEdit = {};
      }
      this.dataToShowSubscription = state;
    },

    editSubscription(pos) {
      this.structureToEdit = this.structures[pos];
      this.changeToShowSubscription(true);
    },

    async refreshHistory() {
      this.isLoading = true;
      this.histories = [];
      await axios
        .get('api/admin/subscription_histories')
        .then((response) => {
          this.histories.push(response.data);
          this.histories = this.histories.flat();
        })
        .catch((error) => console.error(error));

      await axios
        .get('api/admin/register_histories')
        .then((response) => {
          this.histories.push(response.data);
          this.histories = this.histories.flat();
        })
        .catch((error) => console.error(error));

      await axios
        .get('api/admin/detached_histories')
        .then((response) => {
          this.histories.push(response.data);
          this.histories = this.histories.flat();
        })
        .catch((error) => console.error(error));

      this.isLoading = false;
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
